module.exports = __webpack_public_path__ + "static/assets/dc06837c41abb634b5e922927f66d8e6.svg";